import { combineReducers } from "redux";
import reports from "./reports";

export default combineReducers({
    reports 
});